import React, { useContext } from 'react';
import { Grid, Row, Col } from '@sm/wds-react';
import { LanguageMenuLI } from './LanguageMenu';
import { AuthedFooterLinks } from './FooterLinks';
import TrusteSeals from './TrusteSeals';
import BillingAddress from './BillingAddress';
import { SMFooterContext } from './SMFooterContext';

const AuthedFooter = () => {
  const { domain, lang, country, showBillingAddress } = useContext(
    SMFooterContext
  );

  return (
    <div className="sm-footer">
      <Grid>
        <Row>
          <Col className="wds-m-b-5">
            <LanguageMenuLI lang={lang} />
          </Col>
        </Row>
        <Row>
          <Col className="wds-flex wds-flex--y-center wds-m-b-5">
            <div className="wds-flex__item">
              <AuthedFooterLinks domain={domain} lang={lang} />
              {showBillingAddress && <BillingAddress country={country} />}
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <TrusteSeals />
          </Col>
        </Row>
      </Grid>
    </div>
  );
};

export default AuthedFooter;
